module.exports = __webpack_public_path__ + "static/media/reitway-global-property-i.8e8decc6.csv";